module.exports = __webpack_public_path__ + "img/PXL_20230524_111254352.94180a73.jpg";